import { Input, Space, Tooltip, Select } from 'antd';
import { useState, useEffect } from 'react';
import { QAItem } from '../productQA-item';
import styles from '../../index.less';
import editPub from './editPubSub';
import { Highlighter } from '@/components/highlight';
import { DislikeOutlined, LikeOutlined, LikeFilled, DislikeFilled, CloseCircleOutlined, CloseCircleFilled } from '@ant-design/icons';

type ColumnItem = { label: string; prop: string };

const Index: React.FC<{
  autoSize: boolean;
  QA: QAItem;
  item: ColumnItem;
  highlightText: string;
  isActive: Boolean;
  handleJudgement: (value: number, id: number) => void;
}> = ({ autoSize, QA, item, highlightText, isActive, handleJudgement }) => {
  const [formValue, setFormValue] = useState<string>('');
  const [focus, setFocus] = useState<string[]>([]);

  function onChange(value: string) {
    setFormValue(value);
    editPub.onChange(QA.id, item.prop, value);
  }

  function handleClick(value: number) {
    if (QA.judgement !== value) {
      handleJudgement(value, QA.id);
    }
  }

  const alertStyle = {
    height: '100%',
    backgroundColor: 'transparent',
    position: 'relative',
    padding: '6px 0px',
    border: '1px solid',
  } as React.CSSProperties;
  const textAreaStyle = {
    transition: 'all 0.3s ease-out',
    position: 'relative',
  } as React.CSSProperties;

  const iconStyle = { fontSize: 18 } as React.CSSProperties;
  const activeStyle = { color: 'orange' } as React.CSSProperties;

  let isSpecial = false;
  if (['thinking', 'prompt'].includes(item.prop)) {
    isSpecial = true;
    textAreaStyle.caretColor = 'transparent';
  }

  useEffect(() => {
    if (QA) {
      const value = (QA as any)[item.prop];
      setFormValue(isSpecial ? (value || '-') : value);
      if (['question', 'answer'].includes(item.prop))
        editPub.subscribe(QA.id, item.prop, onChange);
    }
  }, [QA]);

  if (item.prop === 'remark') {
    return <Select
      value={formValue}
      style={{ width: 180 }}
      placeholder="请选择备注"
      dropdownMatchSelectWidth={false}
      onChange={(e) => onChange(e)}
      allowClear
    >
      {
        [
          "转人工（健康情况复杂）",
          "转人工（保单分析）",
          "转人工（投保遇到问题）",
          "转人工（其他情况）",
          "推荐其他产品",
          "投保链接",
          "产品详情链接",
          "保险条款",
          "价格表",
          "免责条款",
          "服务手册",
          "特药清单",
          "负面/投诉",
          "保险责任图",
          "投保流程图",
        ].map(vo => <Select.Option key={vo} value={vo}>{vo}</Select.Option>)
      }
    </Select>
  }

  return (
    <div style={alertStyle} className={focus.includes(item.prop) ? styles.qaFocus : styles.qaUnfocus}>
      <div>
        <div
          className="backdrop"
          style={{
            overflow: 'hidden',
            backgroundColor: 'transparent',
            position: 'absolute',
            padding: '4px 11px',
            height: isActive ? 'auto' : '28px',
          }}
        >
          <Highlighter value={formValue} highlight={highlightText} />
        </div>

        <Input.TextArea
          style={textAreaStyle}
          className={styles.qaInput}
          autoSize={autoSize || { minRows: 1, maxRows: 1 }}
          bordered={false}
          placeholder={`${!isSpecial ? `请输入` : ''}${item.label}`}
          value={formValue}
          onChange={(e) => { !isSpecial && onChange(e.target.value) }}
          onFocus={() => setFocus([item.prop])}
          onBlur={() => setFocus([])}
        />
      </div>
      {
        item.prop === 'answer' && QA.permit && <Space style={{ width: '100%', justifyContent: 'flex-end', flexShrink: 0, paddingRight: 16 }}>
          <Tooltip title="好">
            <a onClick={() => handleClick(1)}>
              {QA.judgement === 1 ? <LikeFilled style={{ ...iconStyle, ...activeStyle }} /> : <LikeOutlined style={iconStyle} />}
            </a>
          </Tooltip>

          <Tooltip title="差">
            <a onClick={() => handleClick(2)}>
              {QA.judgement === 2 ? <DislikeFilled style={{ ...iconStyle, ...activeStyle }} /> : <DislikeOutlined style={iconStyle} />}
            </a>
          </Tooltip>

          <Tooltip title="错">
            <a onClick={() => handleClick(3)}>
              {QA.judgement === 3 ? <CloseCircleFilled style={{ ...iconStyle, ...activeStyle }} /> : <CloseCircleOutlined style={iconStyle} />}
            </a>
          </Tooltip>
        </Space>
      }
    </div>
  );
};

export default Index;
